import {
  RELATION__CANDIDATES_STARRED
} from '../../../dictionaries/Relations.dic';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Candidate from '../../../lib/Candidate';
import Core from '../../../lib/Core';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import useState from '../../../lib/hooks/useState.hook';
import {
  mapCandidate
} from '../../../lib/models/candidate';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  COLLECTION__CANDIDATES,
  readLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import Icon from '../../Layout/Wrappers/Icon';
import Menu from '../../Layout/Wrappers/Menu';
import Once from '../../Layout/Wrappers/Once';
import Typography from '../../Layout/Wrappers/Typography';

export default function ActionStarCandidate({
  acl = true,
  candidateId = '',
}) {
  const [state, updateState] = useState();

  if (NOT(acl) || NOT(candidateId)) { return null; }

  const OBJ__CANDIDATE = Obj(state.candidate);

  const fetchCandidate = async () => {
    try {
      updateState({
        candidate: Obj(
          await readLoopbackRecord({
            collection: COLLECTION__CANDIDATES,
            where: { id: candidateId },
            fields: ['id'],
            include: {
              relation: RELATION__CANDIDATES_STARRED,
              scope: {
                where: { accountId: Core.getUserId() },
                limit: 1
              },
            },
            limit: 1,
            mapper: mapCandidate
          })
        )
      });
    }
    catch (error) {
      globalErrorHandler(error);
    }
  }
  return (
    <Menu.Item
      onClick={async (event) => {
        event.stopPropagation();
        try {
          const response = await Candidate.updateStarred(
            OBJ__CANDIDATE.id,
            OBJ__CANDIDATE.starredId,
            !OBJ__CANDIDATE.starred
          );
          OBJ__CANDIDATE.starred = response.starred;
          updateState({
            candidate: OBJ__CANDIDATE
          });
        }
        catch (error) {
          globalErrorHandler(error);
        }
      }}
      divider
    >
      <Once
        promise={fetchCandidate}
        render={false}
      />
      <Typography mr>
        Star candidate
      </Typography>
      <Icon
        icon={OBJ__CANDIDATE.starred ? 'star' : 'star_border'}
        className='c-gray'
      />
    </Menu.Item>
  );
}
